import ContentArea from 'components/content-area/ContentArea';
import { AdditionalComponentProps } from 'source/component-registry';
import { IRichText } from 'source/NFR.types';

// theme for block defined here to avoid circular imports.
const richTextBlockProps = {
  RichTextBlock: { theme: 'rich-text-block--theme-no-padding' }
};

interface IRichTextProps extends IRichText {
  className?: string;
  additionalComponentProps?: AdditionalComponentProps;
}

const RichText: React.FC<IRichTextProps> = props => (
  <ContentArea
    enableElementSizing={false}
    additionalComponentProps={{
      ...props.additionalComponentProps,
      ...richTextBlockProps
    }}
    {...props}
  />
);

RichText.displayName = 'RichText';

export default RichText;
